var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcConiglioBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.51 37.94C33.04 38.49 34.98 39.09 36.36 39.45C36.96 39.15 41.12 37.7 42.58 37.13C43.13 36.62 44.5 34.87 44.86 33.9C45.01 33.41 44.99 32.91 44.86 32.09C44.63 30.69 41.95 22.73 40.16 21.36C39.14 20.58 31.48 17.26 29.37 16.9C27.5 10.99 24 5.14003 19.84 3.39003C17.51 2.41003 16.71 2.89003 16.46 3.58003",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.36 39.4501C36.49 43.4201 34.42 46.1701 31.05 47.1601",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.92 17.81C25.38 15.58 20.58 8.95001 17.02 7.02001C13.46 5.09001 10.79 5.52001 9.90002 6.61001C8.58002 8.22001 12.9 17.21 14.59 19.08C16.28 20.95 18.27 22.94 18.93 23.48C18.81 24.51 18.09 26.86 17.54 27.7C14.28 25.67 9.03003 25.11 5.03003 26.67",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConiglioBlack);
export default __webpack_public_path__ + "static/media/ic_coniglio_black.5a8c8b17f0ead98761a494b7f85306fb.svg";
export { ForwardRef as ReactComponent };